<template>
    <article class="entry entry-infographie">
        <a class="entry-link" :href="postUrl">
            <div class="entry-thumbnail-container">
                <img v-if="thumbnailUrl()"
                     :src="thumbnailUrl()"
                     :alt="title()"
                     class="entry-thumbnail">
                <div class="entry-post-type">
                    {{ post.type }}
                </div>
            </div>
            <h3 class="entry-title">
                {{ title() }}
            </h3>
            <div class="entry-date">
                {{ date }}
            </div>
        </a>
    </article>
</template>

<script>
  import _ from 'lodash'

  export default {

    props: {
      post: {
        type: Object,
        required: true
      }
    },

    computed: {

      postUrl () {
        return '/' + this.post.type + '/' + this.post.slug
      },

      date () {
        return new Date(Date.parse(this.post.date))
          .toLocaleDateString('fr-FR', {
            year: "numeric",
            month: "long",
            day: "numeric"
          })
      },

    },

    methods: {

      title (charLength = 80) {
        return _.truncate(this.post.title.rendered, {
          'length': charLength,
          'separator': ' ',
          'omission': ' (...)'
        })
      },

      thumbnailUrl (size = 'general-entry') {
        if (this.post.hasOwnProperty('_embedded')) {
          if (this.post._embedded.hasOwnProperty('wp:featuredmedia')) {
            if (0 in this.post._embedded['wp:featuredmedia']) {
              if ('media_details' in this.post._embedded['wp:featuredmedia'][0]) {
                if ('sizes' in this.post._embedded['wp:featuredmedia'][0].media_details) {
                  if (size in this.post._embedded['wp:featuredmedia'][0].media_details.sizes) {
                    if ('source_url' in this.post._embedded['wp:featuredmedia'][0].media_details.sizes[size]) {
                      return this.post._embedded['wp:featuredmedia'][0].media_details.sizes[size].source_url
                    }
                  } else if ('full' in this.post._embedded['wp:featuredmedia'][0].media_details.sizes) {
                    return this.post._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url
                  }
                }
              }
            }
          } else {
            return window.initialState.defaultThumbnails[this.post.type][size]
          }
        } else {
          return window.initialState.defaultThumbnails[this.post.type][size]
        }

        return null
      },

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/posts/InforgraphieEntry.vue